// diaryOffline.js — OFFLINE Denník (Mirko 2026-07-12, ústava 39/96.10; Dalux Outbox vzor ako Závady)
// IndexedDB: 'kv' = cache GET dát (zoznam, zákazky, poter katalóg) · 'diary_outbox' = neodoslané zápisy (+ foto bloby).
// Idempotencia: client_uid → server nezduplikuje pri re-syncu. POZOR ústava 39 (antidatovanie): zápis parťáka
// musí byť odoslaný v deň vytvorenia — ak flush zbehne neskôr, server ho odmietne a položka ostáva s chybou pre majstra.
import { fetchAuth } from '../auth/fetchAuth.js'

let idb = null
function idbOpen() {
  return new Promise((res, rej) => {
    if (idb) return res(idb)
    const q = indexedDB.open('kamir_dennik', 1)
    q.onupgradeneeded = () => {
      const d = q.result
      if (!d.objectStoreNames.contains('kv')) d.createObjectStore('kv')
      if (!d.objectStoreNames.contains('diary_outbox')) d.createObjectStore('diary_outbox', { keyPath: 'client_uid' })
    }
    q.onsuccess = () => { idb = q.result; res(idb) }
    q.onerror = () => rej(q.error)
  })
}
export async function kvGet(k) { try { const d = await idbOpen(); return await new Promise(res => { const t = d.transaction('kv').objectStore('kv').get(k); t.onsuccess = () => res(t.result); t.onerror = () => res(undefined) }) } catch (_) { return undefined } }
export async function kvSet(k, v) { try { const d = await idbOpen(); return await new Promise(res => { const t = d.transaction('kv', 'readwrite').objectStore('kv').put(v, k); t.onsuccess = () => res(true); t.onerror = () => res(false) }) } catch (_) { return false } }
export async function obAll() { try { const d = await idbOpen(); return await new Promise(res => { const t = d.transaction('diary_outbox').objectStore('diary_outbox').getAll(); t.onsuccess = () => res(t.result || []); t.onerror = () => res([]) }) } catch (_) { return [] } }
export async function obPut(item) { try { const d = await idbOpen(); return await new Promise(res => { const t = d.transaction('diary_outbox', 'readwrite').objectStore('diary_outbox').put(item); t.onsuccess = () => res(true); t.onerror = () => res(false) }) } catch (_) { return false } }
export async function obDel(uidKey) { try { const d = await idbOpen(); return await new Promise(res => { const t = d.transaction('diary_outbox', 'readwrite').objectStore('diary_outbox').delete(uidKey); t.onsuccess = () => res(true); t.onerror = () => res(false) }) } catch (_) { return false } }
export const newUid = () => 'C' + Date.now().toString(36) + Math.random().toString(36).slice(2, 9)

// kompresia fotky ~1600px JPEG (šetrí iPhone úložisko aj dáta) — rovnaké ako Závady
export function compressPhoto(file) {
  return new Promise((res) => {
    try {
      const img = new Image(); const u = URL.createObjectURL(file)
      img.onload = () => {
        try {
          const MAX = 1600; let w = img.width, h = img.height
          const r = Math.min(1, MAX / Math.max(w, h)); w = Math.round(w * r); h = Math.round(h * r)
          const c = document.createElement('canvas'); c.width = w; c.height = h
          c.getContext('2d').drawImage(img, 0, 0, w, h)
          c.toBlob(b => { URL.revokeObjectURL(u); res(b && b.size < file.size ? b : file) }, 'image/jpeg', 0.82)
        } catch (_) { URL.revokeObjectURL(u); res(file) }
      }
      img.onerror = () => { URL.revokeObjectURL(u); res(file) }
      img.src = u
    } catch (_) { res(file) }
  })
}

// flush: zápis (POST s client_uid) → fotky (POST FormData) → zmaž z outboxu.
// 4xx (napr. antidatovanie 403) = trvalá chyba → položka ostáva s err (majster rieši). Sieťová chyba = stop, skús neskôr.
let flushing = false
// opts.ajChybne (DENNIK_TUK_V1): ručné „skús hneď“ pošle aj zápisy, ktoré server už odmietol; samo sa posielajú len neodmietnuté
export async function flushDiary(opts) {
  if (flushing || !navigator.onLine) return { sent: 0 }
  flushing = true
  let sent = 0
  try {
    for (const it of await obAll()) {
      try {
        // DENNIK_TUK_V1: zápis na ťuk = jedna požiadavka so zápisom aj fotkami (client_uid → server nezduplikuje)
        if (it.tuk && it.err && !(opts && opts.ajChybne)) continue   // odmietnutý zápis sa neposiela dookola (dáta, batéria)
        if (it.tuk) {
          const fd = new FormData(); fd.append('data', JSON.stringify({ ...(it.data || {}), client_uid: it.client_uid }))
          ;(it.fotky || []).forEach((f, i) => fd.append(f.pole || 'foto', f.blob, (f.pole || 'foto') + '_' + (i + 1) + '.jpg'))
          const r = await fetchAuth('/api/diary/zapis', { method: 'POST', body: fd })
          const d = await r.json().catch(() => ({}))
          if (r.ok) { await obDel(it.client_uid); sent++ }
          else if (r.status >= 400 && r.status < 500) { await obPut({ ...it, err: d.message || d.error || ('Chyba ' + r.status) }) }
          else break
          continue
        }
        if (it.photos_only) {
          if ((it.blobs || []).length) {
            const fd = new FormData(); it.blobs.forEach((b, i) => fd.append('photos', b, 'foto' + (i + 1) + '.jpg'))
            const pr = await fetchAuth('/api/diary/' + it.body.project_id + '/photos/' + it.photos_only, { method: 'POST', body: fd })
            if (pr.ok) { await obDel(it.client_uid); sent++ }
            else if (pr.status >= 400 && pr.status < 500) { await obPut({ ...it, err: 'Fotky ' + pr.status }) }
            else break
          } else { await obDel(it.client_uid) }
          continue
        }
        const r = await fetchAuth('/api/diary/project/' + it.body.project_id, { method: 'POST', body: JSON.stringify({ ...it.body, client_uid: it.client_uid }) })
        const d = await r.json().catch(() => ({}))
        if (r.ok) {
          if ((it.blobs || []).length && d.id) {
            const fd = new FormData();
            it.blobs.forEach((b, i) => fd.append('photos', b, 'foto' + (i + 1) + '.jpg'))
            try {
              const pr = await fetchAuth('/api/diary/' + it.body.project_id + '/photos/' + d.id, { method: 'POST', body: fd })
              if (!pr.ok) throw new Error('photos ' + pr.status)
              await obDel(it.client_uid); sent++
            } catch (_) {
              await obPut({ ...it, photos_only: d.id }); break // zápis JE na serveri, fotky padli → NEZMAŽ, skús len fotky neskôr
            }
          } else { await obDel(it.client_uid); sent++ }
        } else if (r.status >= 400 && r.status < 500) {
          await obPut({ ...it, err: d.error || ('Chyba ' + r.status) })
        } else break
      } catch (_) { break } // offline / server down — skús neskôr
    }
  } finally { flushing = false }
  return { sent }
}
